<template>
  <h2>Work Summary</h2>
  <p>
    I started my career in Graphic Design and Desktop Publishing. I've been in
    the Digital Marketing space since 2005 with various companies and roles.
  </p>
  <div class="job__wrapper">
    <div
      v-for="job in jobz"
      class="workhistory__tile--small"
      v-bind:key="job.id"
    >
      <div class="img-wrap">
        <img
          v-if="this.activeTheme === 'dark-theme'"
          class="logo--small"
          v-bind:src="job.logoDark"
        />
        <img v-else class="logo--small" v-bind:src="job.logo" />

        <!-- <picture>
          <source :srcset="job.logoDark" media="(prefers-color-scheme: dark)" />
          <img class="logo--small" :src="job.logo" />
        </picture> -->
      </div>
      <p class="company">{{ job.company }}</p>
      <p class="date">{{ job.fullDate }}</p>
      <!-- <div v-for="role in job.roles" class="tile__inner" v-bind:key="role.id">
        <p class="">{{ role.title }}</p>
      </div> -->
    </div>
  </div>
  <h2>Work Detail</h2>
  <section id="workHistory">
    <div v-for="job in jobz" class="workhistory__tile" v-bind:key="job.id">
      <img class="logo" v-bind:src="job.logo" />
      <div class="company-info">
        <p class="company">{{ job.company }}</p>
        <p class="tenure">{{ job.tenure }}</p>
      </div>
      <div v-for="role in job.roles" class="tile__inner" v-bind:key="role.id">
        <div class="role">
          <p class="title">{{ role.title }}</p>
          <p class="date">{{ role.date }}</p>
        </div>
        <div
          v-for="description in role.descriptions"
          v-bind:key="description.id"
          class="description"
        >
          <p>{{ description }}</p>
        </div>
        <div class="tags">
          <div v-for="tag in role.tags" v-bind:key="tag.id" class="tag">
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { jobz } from "../../data.js"

  export default {
    name: "WorkHistory",
    props: ["userTheme", "activeTheme"],
    data() {
      return {
        jobz,
        headline: "Why are you here?",
      }
    },
    methods: {},
    // watch: {
    //   activeTheme: function() {
    //     console.log(this.activeTheme)
    //   },
    // },
  }
  // if (element.classList.contains('is-valid')) {
</script>

<style lang="scss"></style>
